<template>
  <div class="page">
    <van-swipe class="banner-list" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item,index) in articleDetail.bannerList">
        <img class="banner-item" :src="item" alt="" @click="onBannerItemClick(index)">
      </van-swipe-item>
    </van-swipe>
    <div class="header">
      <div class="header-title">{{ articleDetail.title }}</div>
      <div class="row" style="margin-bottom: 4vw">
        <img class="header-icon"
             src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/20260729175743cddbb61fa2a204e82d68c21202960bf1.png"
             alt="">
        <div class="header-text" style="margin-left: 2vw;">{{ articleDetail.createTime }}</div>
        <img class="header-icon" style="margin-left: 8vw;"
             src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/20260729180317bd5cd692b98e8db03e84fb4ad5b6aea4.png"
             alt="">
        <div class="header-text" style="margin-left: 2vw;">{{ articleDetail.viewCount }}</div>
        <img class="header-icon" style="margin-left: 4vw;"
             :src="articleDetail.isLike?'https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/20260729180733512263e285d27fba4be344fa54083d32.png':'https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/20260729180606631fa5822c952beab9047e349d335917.png'"
             alt="" @click="onLikeClick()">
        <div class="header-text" style="margin-left: 2vw;">点赞</div>
        <img class="header-icon" style="margin-left: 2vw;"
             :src="articleDetail.isFavourite?'https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/20260729180922bbe1c76ae2796c276f0e61872a3fed4e.png':'https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/2026072918070953d63c356699f8aa4a230b7f09548a6f.png'"
             alt="" @click="onFavouriteClick()">
        <div class="header-text" style="margin-left: 2vw;">收藏</div>
      </div>
    </div>
    <div class="title">基本信息</div>
    <div class="information">
      <div class="row">
        <div class="information-label">类别</div>
        <div class="information-value">{{ articleDetail.category }}</div>
      </div>
      <div class="row">
        <div class="information-label">价格</div>
        <div class="information-value" style="color: #FF0000">{{ articleDetail.price }}元</div>
      </div>
      <div class="row">
        <div class="information-label">地址</div>
        <div class="information-value">{{ articleDetail.address }}</div>
      </div>
      <div class="row">
        <div class="information-label">联系人</div>
        <div class="information-value">{{ articleDetail.contactName }}</div>
      </div>
      <div class="row">
        <div class="information-label">联系电话</div>
        <div class="information-value" style="color: #0000FF;text-decoration: underline;">{{
            articleDetail.contactPhone
          }}
        </div>
      </div>
    </div>
    <div class="title">详情介绍</div>
    <div class="introduction">
      <div class="introduction-text">{{ articleDetail.text }}</div>
    </div>
    <div class="title">服务优势</div>
    <div class="advantage">
      <div class="advantage-item row">
        <div class="advantage-item-count">1</div>
        <div class="advantage-item-text">咨询预约</div>
      </div>
      <div class="advantage-item row">
        <div class="advantage-item-count">2</div>
        <div class="advantage-item-text">上门接宠 / 到店送宠</div>
      </div>
      <div class="advantage-item row">
        <div class="advantage-item-count">3</div>
        <div class="advantage-item-text">遗体清洁整理</div>
      </div>
      <div class="advantage-item row">
        <div class="advantage-item-count">4</div>
        <div class="advantage-item-text">告别仪式</div>
      </div>
      <div class="advantage-item row">
        <div class="advantage-item-count">5</div>
        <div class="advantage-item-text">留取纪念（爪印、毛发等）</div>
      </div>
      <div class="advantage-item row">
        <div class="advantage-item-count">6</div>
        <div class="advantage-item-text">一宠一炉单独火化</div>
      </div>
      <div class="advantage-item row">
        <div class="advantage-item-count">7</div>
        <div class="advantage-item-text">骨灰整理</div>
      </div>
      <div class="advantage-item row">
        <div class="advantage-item-count">8</div>
        <div class="advantage-item-text">骨灰装罐</div>
      </div>
      <div class="advantage-item row">
        <div class="advantage-item-count">9</div>
        <div class="advantage-item-text">骨灰安置</div>
      </div>
      <div class="advantage-item row">
        <div class="advantage-item-count">10</div>
        <div class="advantage-item-text">持续关怀</div>
      </div>
    </div>
    <!--    <div class="title">服务流程</div>-->
    <!--    <div class="flow">-->
    <!--      <div class="row">-->
    <!--        <div class="flow-item">服务流程</div>-->
    <!--        <img class="flow-icon"-->
    <!--             src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/202607291849441edd3c997b567dab58b342bf4d1fb16a.png"-->
    <!--             alt="">-->
    <!--        <div class="flow-item">服务流程</div>-->
    <!--        <img class="flow-icon"-->
    <!--             src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/202607291849441edd3c997b567dab58b342bf4d1fb16a.png"-->
    <!--             alt="">-->
    <!--        <div class="flow-item">服务流程</div>-->
    <!--      </div>-->
    <!--      <div class="row">-->
    <!--        <div class="flow-item">服务流程</div>-->
    <!--        <img class="flow-icon"-->
    <!--             src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/202607291849441edd3c997b567dab58b342bf4d1fb16a.png"-->
    <!--             alt="">-->
    <!--        <div class="flow-item">服务流程</div>-->
    <!--        <img class="flow-icon"-->
    <!--             src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/202607291849441edd3c997b567dab58b342bf4d1fb16a.png"-->
    <!--             alt="">-->
    <!--        <div class="flow-item">服务流程</div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="title">预约咨询</div>
    <div class="order">
      <input class="order-input" v-model="form.city" placeholder="请输入城市">
      <input class="order-input" v-model="form.phone" type="number" placeholder="请输入11位数手机号码">
      <div class="order-submit" @click="onSubmitClick()">提 交 预 约</div>
    </div>
    <div class="title">猜你喜欢</div>
    <div class="article-list">
      <div class="article-item" v-for="item in articleList" @click="onArticleItemClick(item)">
        <div class="row">
          <img class="article-item-cover" :src="item.cover" alt="">
          <div>
            <div class="article-item-title double-line">{{ item.title }}</div>
            <div class="article-item-category single-line">{{ item.category }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="city-title">其他城市</div>
    <div class="city-list row">
      <div class="city-item" v-for="item in cityList" @click="onCityItemClick(item)"
           v-if="item.id!='1'&&item.domain!=domain">{{ item.name }}
      </div>
    </div>
    <div style="height: 12vw"></div>
    <div class="bottom">粤ICP备2025363000号-14</div>
    <div style="height: 24vw"></div>
    <div class="tabbar row">
      <div class="tabbar-order" @click="onTabbarOrderClick()">预 约</div>
      <div class="tabbar-service" @click="onTabbarServiceClick()">客 服</div>
      <div class="tabbar-phone" @click="onTabbarPhoneClick()">拨 打 电 话</div>
    </div>
    <div class="mask" @click="onEuthanasiaDialogClose" v-if="orderDialogShow">
      <div class="euthanasia-sheet" @click.stop="onDialogTap">
        <div class="euthanasia-header">
          <div class="euthanasia-title">宠物殡葬</div>
          <img class="euthanasia-close"
               src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/202607292028524a7a6c6fabf9fbdf9e3f692d0360b3f6.png"
               alt="" @click="onEuthanasiaDialogClose">
        </div>
        <div class="euthanasia-body">
          <div class="euthanasia-desc">长按识别二维码，添加好友咨询宠物殡葬服务</div>
          <div class="euthanasia-qr-wrap">
            <img class="euthanasia-qr"
                 src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/20260722122757f78892d16c1bdd66dcdbef02c71ff9ca.jpg"
                 alt="">
          </div>
          <div class="euthanasia-tip">微信号：furryferry</div>
          <div class="euthanasia-copy-btn" @click="onCopyWechat">复制微信号</div>
        </div>
      </div>
    </div>
    <div class="mask" @click="onEuthanasiaDialogClose" v-if="serviceDialogShow">
      <div class="euthanasia-sheet" @click.stop="onDialogTap">
        <div class="euthanasia-header">
          <div class="euthanasia-title">宠物殡葬</div>
          <img class="euthanasia-close"
               src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/202607292028524a7a6c6fabf9fbdf9e3f692d0360b3f6.png"
               alt="" @click="onEuthanasiaDialogClose">
        </div>
        <div class="euthanasia-body">
          <div class="euthanasia-desc">长按识别二维码，添加好友咨询宠物殡葬服务</div>
          <div class="euthanasia-qr-wrap">
            <img class="euthanasia-qr"
                 src="https://liaoming-1257130299.cos.ap-guangzhou.myqcloud.com/20260722123231aeef1df8660b8eb8a0bf615b4139d97c.jpg"
                 alt="">
          </div>
          <div class="euthanasia-tip">微信号：furryferry</div>
          <div class="euthanasia-copy-btn" @click="onCopyWechat">复制微信号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/api";
import {ImagePrediv} from "vant";

export default {
  name: "Article",
  data: function () {
    return {
      orderDialogShow: false,
      serviceDialogShow: false,
      articleDetail: {},
      articleList: [],
      cityList: [],
      form: {
        city: "",
        phone: ""
      }
    }
  },
  mounted: function () {
    this.domain = window.location.hostname.split(".").length >= 3 ? window.location.hostname.split(".")[window.location.hostname.split(".").length - 3] : "";
    this.articleId = this.$route.params.articleId;
    this.getArticle();
    this.getArticleList();
    this.getCityList();
  },
  methods: {
    getArticle: function () {
      var _this = this;
      var data = {
        articleId: _this.articleId
      };
      api.getArticle(data).then(function (response) {
        _this.articleDetail = response.responseData;
      });
    },
    getArticleList: function () {
      var _this = this;
      var data = {
        domain: _this.domain,
        type: "random",
        pageCount: 1,
        pageSize: 10
      };
      api.getArticleList(data).then(function (response) {
        _this.articleList = response.responseData.articleList;
      });
    },
    getCityList: function () {
      var _this = this;
      var data = {};
      api.getCityList(data).then(function (response) {
        _this.cityList = response.responseData.cityList;
      });
    },
    addOrder: function () {
      var _this = this;
      var data = {
        city: _this.form.city,
        phone: _this.form.phone
      };
      api.addOrder(data).then(function (response) {
        _this.$toast("提交成功");
        _this.form.city = "";
        _this.form.phone = "";
      });
    },
    onBannerItemClick: function (index) {
      ImagePrediv({
        images: this.articleDetail.bannerList,
        startPosition: index
      });
    },
    onLikeClick: function () {
      this.$set(this.articleDetail, 'isLike', !this.articleDetail.isLike);
    },
    onFavouriteClick: function () {
      this.$set(this.articleDetail, 'isFavourite', !this.articleDetail.isFavourite);
    },
    onPhoneClick: function () {
      window.location.href = "tel:" + this.articleDetail.contactPhone;
    },
    onSubmitClick: function () {
      if (!this.form.city || !this.form.phone) {
        this.$toast("请输入完整信息");
      } else {
        this.addOrder();
      }
    },
    onArticleItemClick: function (item) {
      this.$router.push({name: "article", params: {articleId: item.id}});
      this.$router.go(0);
    },
    onCityItemClick: function (item) {
      window.location.href = window.location.href.replace(this.domain, item.domain).split("/article")[0];
    },
    onTabbarOrderClick: function () {
      this.orderDialogShow = true;
    },
    onTabbarServiceClick: function () {
      this.serviceDialogShow = true;
    },
    onTabbarPhoneClick: function () {
      window.location.href = "tel:19926596967";
    },
    onDialogTap: function () {

    },
    onEuthanasiaDialogClose: function () {
      this.orderDialogShow = false;
      this.serviceDialogShow = false;
    },
    onCopyWechat: function () {
      var text = "furryferry";
      var _this = this;
      _this.$copyText(text).then(function (e) {
        _this.$toast("复制成功");
      }, function (e) {
        _this.$toast("复制失败！");
      });
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-color: #F2F2F2;
}

.banner-list {
  width: 92vw;
  height: 60vw;
  margin-left: 4vw;
  padding-top: 4vw;
  border-radius: 4vw;
}

.banner-item {
  width: 92vw;
  height: 60vw;
  border-radius: 4vw;
  object-fit: cover;
}

.header {
  width: 84vw;
  margin-top: 4vw;
  margin-left: 4vw;
  padding: 4vw;
  border-radius: 4vw;
  background-color: #FFFFFF;
}

.header-title {
  width: 84vw;
  margin-bottom: 4vw;
  font-size: 5vw;
  line-height: 10vw;
  font-weight: bold;
}

.header-icon {
  width: 4vw;
  height: 4vw;
}

.header-text {
  height: 4vw;
  font-size: 4vw;
  line-height: 4vw;
  color: #999999;
}

.title {
  width: 92vw;
  height: 18vw;
  margin-left: 4vw;
  font-size: 5vw;
  line-height: 18vw;
  text-align: center;
  font-weight: bold;
}

.information {
  width: 84vw;
  margin-left: 4vw;
  padding: 4vw;
  border-radius: 4vw;
  background-color: #FFFFFF;
}

.information-label {
  width: 20vw;
  height: 12vw;
  font-size: 4vw;
  line-height: 12vw;
  color: #999999;
}

.information-value {
  width: 64vw;
  height: 12vw;
  font-size: 4vw;
  line-height: 12vw;
}

.introduction {
  width: 84vw;
  margin-left: 4vw;
  padding: 4vw;
  border-radius: 4vw;
  background-color: #FFFFFF;
}

.introduction-text {
  width: 84vw;
  font-size: 4vw;
  line-height: 8vw;
  white-space: pre-wrap;
}

.advantage {
  width: 84vw;
  margin-left: 4vw;
  padding: 4vw;
  border-radius: 4vw;
  background-color: #FFFFFF;
}

.advantage-item {
  width: 82vw;
  height: 18vw;
  margin: 4vw 0;
  border: 1px solid #E8E8E8;
  border-radius: 2vw;
}

.advantage-item-count {
  width: 8vw;
  height: 18vw;
  font-size: 6vw;
  line-height: 18vw;
  font-weight: bold;
  text-align: center;
  border-radius: 2vw;
  color: #FFFFFF;
  background-color: #FF7270;
}

.advantage-item-text {
  width: 70vw;
  height: 18vw;
  margin-left: 4vw;
  font-size: 5vw;
  line-height: 18vw;
}

.flow {
  width: 84vw;
  margin-left: 4vw;
  padding: 4vw;
  border-radius: 4vw;
  background-color: #FFFFFF;
}

.flow-item {
  width: 22vw;
  height: 18vw;
  margin: 4vw 0;
  font-size: 4vw;
  line-height: 18vw;
  text-align: center;
  border: 1px solid #E8E8E8;
  border-radius: 2vw;
}

.flow-icon {
  width: 4vw;
  height: 4vw;
  margin: 11vw 2vw;
}

.order {
  width: 84vw;
  margin-left: 4vw;
  padding: 4vw;
  border-radius: 4vw;
  background-color: #FFFFFF;
}

.order-input {
  width: 76vw;
  height: 10vw;
  margin: 2vw 0;
  padding: 0 4vw;
  font-size: 4vw;
  line-height: 10vw;
  border-radius: 2vw;
  border: none;
  background-color: #F5F5F5;
}

.order-submit {
  width: 52vw;
  height: 10vw;
  margin: 4vw 0;
  margin-left: 16vw;
  font-size: 4vw;
  line-height: 10vw;
  text-align: center;
  border-radius: 5vw;
  color: #FFFFFF;
  background-color: #EE4341;
}

.article-list {
  width: 92vw;
  margin-left: 4vw;
  padding: 4vw 0;
  border-radius: 4vw;
  background: #FFFFFF;
}

.article-item {
  width: 84vw;
  height: 16vw;
  padding: 4vw;
  border-radius: 4vw;
}

.article-item-cover {
  width: 22vw;
  height: 16vw;
  border-radius: 2vw;
  object-fit: cover;
}

.article-item-title {
  width: 58vw;
  height: 10vw;
  margin-left: 4vw;
  font-size: 4vw;
  line-height: 5vw;
  font-weight: bold;
}

.article-item-category {
  width: 58vw;
  height: 4vw;
  margin-top: 2vw;
  margin-left: 4vw;
  font-size: 3vw;
  line-height: 4vw;
  color: #999999;
}

.city-title {
  width: 92vw;
  height: 12vw;
  margin-top: 4vw;
  margin-left: 4vw;
  font-size: 5vw;
  line-height: 12vw;
  font-weight: bold;
}

.city-list {
  flex-wrap: wrap;
  padding-bottom: 4vw;
}

.city-item {
  width: 20vw;
  height: 8vw;
  margin-top: 4vw;
  margin-left: 4vw;
  font-size: 4vw;
  line-height: 8vw;
  text-align: center;
  border-radius: 2vw;
  background-color: #DDDDDD;
}

.bottom {
  width: 100%;
  height: 12vw;
  font-size: 3vw;
  line-height: 8vw;
  text-align: center;
}

.tabbar {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 20vw;
  border-top: 1px solid #F5F5F5;
  background-color: #FFFFFF;
}

.tabbar-order {
  width: 20vw;
  height: 10vw;
  margin-top: 2vw;
  margin-left: 4vw;
  font-size: 4vw;
  line-height: 10vw;
  text-align: center;
  border-radius: 2vw;
  border: 1px solid #6186E6;
  color: #6186E6;
  background-color: #FFFFFF;
}

.tabbar-service {
  width: 20vw;
  height: 10vw;
  margin-top: 2vw;
  margin-left: 4vw;
  font-size: 4vw;
  line-height: 10vw;
  text-align: center;
  border-radius: 2vw;
  border: 1px solid #6186E6;
  color: #FFFFFF;
  background-color: #6186E6;
}

.tabbar-phone {
  width: 42vw;
  height: 10vw;
  margin-top: 2vw;
  margin-left: 4vw;
  font-size: 4vw;
  line-height: 10vw;
  text-align: center;
  border-radius: 2vw;
  border: 1px solid #FF7270;
  color: #FFFFFF;
  background-color: #FF7270;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.55);
}

.euthanasia-sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 4vw 4vw 0 0;
  padding-bottom: env(safe-area-inset-bottom);
  z-index: 999;
  overflow: hidden;
}

.euthanasia-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 4vw 4vw 4vw;
  border-bottom: 1px solid #f0f0f0;
}

.euthanasia-title {
  font-size: 4vw;
  font-weight: bold;
  color: #1a1a1a;
}

.euthanasia-close {
  position: absolute;
  right: 4vw;
  top: 50%;
  transform: translateY(-50%);
  width: 4vw;
  height: 4vw;
  opacity: 0.45;
}

.euthanasia-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4vw 4vw 4vw;
}

.euthanasia-desc {
  font-size: 4vw;
  color: #666;
  text-align: center;
  margin-bottom: 4vw;
  line-height: 4vw
}

.euthanasia-qr-wrap {
  width: 52vw;
  height: 52vw;
  background: #ffffff;
  border: 2px solid #f0f0f0;
  border-radius: 2vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2vw;
  box-sizing: border-box;
}

.euthanasia-qr {
  width: 100%;
  height: 100%;
}

.euthanasia-tip {
  font-size: 4vw;
  color: #999;
  margin-top: 4vw;
}

.euthanasia-copy-btn {
  margin-top: 4vw;
  width: 100%;
  height: 12vw;
  background: linear-gradient(135deg, #1a3a6b 0%, #2e6eb5 100%);
  color: #ffffff;
  font-size: 4vw;
  font-weight: bold;
  text-align: center;
  line-height: 12vw;
  border-radius: 6vw;
  letter-spacing: 2px;
}
</style>
